import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as Facebook } from '../../assets/images/icons/social/facebook.svg';
import { ReactComponent as Instagram } from '../../assets/images/icons/social/instagram.svg';
import { ReactComponent as Pinterest } from '../../assets/images/icons/social/pinterest.svg';
import { ReactComponent as TikTok } from '../../assets/images/icons/social/tiktok.svg';
import { ReactComponent as Twitter } from '../../assets/images/icons/social/twitter.svg';
import { ReactComponent as AppleAppStore } from '../../assets/images/apple_app_store.svg';
import { ReactComponent as GoogleAppStore } from '../../assets/images/google_app_store.svg';
import { getDomainConfig } from '../../lib/domainConfig';
import { Copyright } from './Copyright';
import styles from './Footer.module.scss';
import JoinEmailForm from './JoinEmailForm';
import { SocialButton } from './SocialButton';
import { getFiOneTrust } from '../../lib/oneTrust';

export default function Footer() {
  const { t } = useTranslation();
  const oneTrustIsAvailable = getFiOneTrust().isAvailable();
  const { baseDomain, supportDomain, nanoDomain } = getDomainConfig();

  return (
    <footer className={styles.footer}>
      <div className={classNames(styles.footerSection, styles.footerSectionNav)}>
        <ul role="navigation" className={styles.footerNav}>
          <li>
            <a href="https://jobs.lever.co/fi" target="_blank" rel="noopener noreferrer">
              {t('jobs')}
            </a>
          </li>
          <li>
            <a href="mailto:press@tryfi.com" target="_blank" rel="noopener noreferrer">
              {t('press')}
            </a>
          </li>
          <li>
            <a href={`https://${baseDomain}/privacypolicy`} target="_blank" rel="noreferrer">
              {t('privacy_policy')}
            </a>
          </li>
          <li>
            <a href={`https://${baseDomain}/cookiepolicy`} target="_blank" rel="noreferrer">
              {t('cookie_policy')}
            </a>
          </li>
          {oneTrustIsAvailable && (
            <li>
              <button id="ot-sdk-btn" className={classNames(styles.buttonAsLink, 'ot-sdk-show-settings')}>
                {t('your_privacy_choices')}
              </button>
            </li>
          )}
          <li>
            <a href={`https://${baseDomain}/tos`} target="_blank" rel="noreferrer">
              {t('terms_of_service')}
            </a>
          </li>
          <li>
            <a href={`https://${supportDomain}/hc/en-us`} target="_blank" rel="noopener noreferrer">
              {t('support')}
            </a>
          </li>
          <li>
            <a href={`https://${nanoDomain}/`} target="_blank" rel="noopener noreferrer">
              {t('nano')}
            </a>
          </li>
        </ul>
        <div className={styles.copyrightDesktop}>
          <Copyright />
        </div>
      </div>
      <div className={styles.footerSection}>
        <div>
          <div className={styles.emailFormHeader}>{t('join_our_newsletter')}</div>
          <div className={styles.emailFormSubHeader}>
            {t('all_the_dog_news_youll_obsess_over_in_one_place_twice_a_month')}
          </div>
        </div>
        <JoinEmailForm placeholder={t('enter_email')} />
        <div className={styles.appStoreButtons}>
          <a
            href="https://apps.apple.com/us/app/fi-gps-dog-tracker/id1438036784"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.appStoreButton}
          >
            <AppleAppStore />
          </a>
          <a
            href="https://play.google.com/store/apps/details?id=com.barkinglabs.fi"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.appStoreButton}
          >
            <GoogleAppStore />
          </a>
        </div>
        <div className={styles.socialLinks}>
          <SocialButton href="https://www.facebook.com/dogcollarsbyfi/" icon={<Facebook />} />
          <SocialButton href="https://www.instagram.com/fi.tracking/" icon={<Instagram />} />
          <SocialButton href="https://twitter.com/fi_dogs" icon={<Twitter />} />
          <SocialButton href="https://www.pinterest.com/fidogs/" icon={<Pinterest />} />
          <SocialButton href="https://www.tiktok.com/@fi.dogs" icon={<TikTok />} />
        </div>
      </div>
      <div className={styles.copyrightMobile}>
        <Copyright />
      </div>
    </footer>
  );
}
